import * as d3 from 'd3';
import { TestResult } from '../../tests/tests';

// This is so ugly that it has its own file.
export default function aggregateResults(results: TestResult[]) {
  // index is `${noNodes},${maxCapacity}`
  const aggregatedResults: {
    [key: string]: {
      noNodes: number;
      maxCapacity: number;
      noInstances: number;
      sameFlowValueAcrossAlgorithms: {
        ok: boolean;
        testTest: boolean;
      };
      individualResults: {
        satisfiesPreservation: {
          ok: boolean;
          testTest: boolean;
        };
        satisfiesCapacity: {
          ok: boolean;
          testTest: boolean;
        };
        hasSaturatedCut: {
          ok: boolean;
          testTest: boolean;
        };
        runtime: {
          min: number;
          q1: number;
          median: number;
          q3: number;
          max: number;
        };
      }[];
    };
  } = {};
  const runtimeData: {
    [key: string]: number[][];
  } = {};
  for (const result of results) {
    const i = `${result.noNodes},${result.maxCapacity}`;
    if (aggregatedResults[i]) {
      for (let j = 0; j <= 3; j += 1) {
        runtimeData[i][j].push(result.individualResults[j].runtime);
        aggregatedResults[i].individualResults[j].satisfiesPreservation.ok =
          aggregatedResults[i].individualResults[j].satisfiesPreservation.ok &&
          result.individualResults[j].satisfiesPreservation.ok;
        aggregatedResults[i].individualResults[j].satisfiesPreservation.testTest =
          aggregatedResults[i].individualResults[j].satisfiesPreservation.testTest &&
          result.individualResults[j].satisfiesCapacity.ok;
        aggregatedResults[i].individualResults[j].satisfiesCapacity.ok =
          aggregatedResults[i].individualResults[j].satisfiesCapacity.ok &&
          result.individualResults[j].satisfiesCapacity.ok;
        aggregatedResults[i].individualResults[j].satisfiesCapacity.testTest =
          aggregatedResults[i].individualResults[j].satisfiesCapacity.testTest &&
          result.individualResults[j].hasSaturatedCut.ok;
        aggregatedResults[i].individualResults[j].hasSaturatedCut.ok =
          aggregatedResults[i].individualResults[j].hasSaturatedCut.ok &&
          result.individualResults[j].hasSaturatedCut.ok;
        aggregatedResults[i].individualResults[j].hasSaturatedCut.testTest =
          aggregatedResults[i].individualResults[j].hasSaturatedCut.testTest &&
          result.individualResults[j].hasSaturatedCut.ok;
      }
      aggregatedResults[i].noInstances += 1;
      aggregatedResults[i].sameFlowValueAcrossAlgorithms.ok =
        aggregatedResults[i].sameFlowValueAcrossAlgorithms.ok &&
        result.sameFlowValueAcrossAlgorithms.ok;
    } else {
      runtimeData[i] = {} as any;
      aggregatedResults[i] = {
        sameFlowValueAcrossAlgorithms: result.sameFlowValueAcrossAlgorithms,
        noNodes: result.noNodes,
        maxCapacity: result.maxCapacity,
        noInstances: 1,
        individualResults: []
      };
      for (let j = 0; j <= 3; j += 1) {
        runtimeData[i][j] = [result.individualResults[j].runtime];
        aggregatedResults[i].individualResults[j] = {
          satisfiesPreservation: {
            ok: result.individualResults[j].satisfiesPreservation.ok,
            testTest: result.individualResults[j].satisfiesPreservation.testTest
          },
          satisfiesCapacity: {
            ok: result.individualResults[j].satisfiesCapacity.ok,
            testTest: result.individualResults[j].satisfiesCapacity.testTest
          },
          hasSaturatedCut: {
            ok: result.individualResults[j].hasSaturatedCut.ok,
            testTest: result.individualResults[j].hasSaturatedCut.testTest
          },
          runtime: {
            min: 0,
            q1: 0,
            median: 0,
            q3: 0,
            max: 0
          }
        };
      }
    }
  }
  for (const i of Object.keys(aggregatedResults)) {
    const r = aggregatedResults[i];
    for (let j = 0; j <= 3; j += 1) {
      r.individualResults[j].runtime.min = d3.quantile(runtimeData[i][j], 0) as number;
      r.individualResults[j].runtime.q1 = d3.quantile(runtimeData[i][j], 0.25) as number;
      r.individualResults[j].runtime.median = d3.quantile(runtimeData[i][j], 0.5) as number;
      r.individualResults[j].runtime.q3 = d3.quantile(runtimeData[i][j], 0.75) as number;
      r.individualResults[j].runtime.max = d3.quantile(runtimeData[i][j], 1) as number;
    }
    aggregatedResults[i] = r;
  }
  return Object.values(aggregatedResults);
}
